import CTAButton from './CTAButton.jsx'

export default function PricingCard({ plan }) {
  const { emoji, name, price, badge, highlight, description, features, cta, ctaTo, available } = plan

  return (
    <div
      className={`relative flex flex-col rounded-2xl p-8 border-2 transition-shadow hover:shadow-lg ${
        highlight
          ? 'border-kart-action bg-white shadow-xl ring-4 ring-kart-action/10'
          : 'border-slate-200 bg-white'
      }`}
    >
      {highlight && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2">
          <span className="bg-kart-action text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wide shadow">
            Disponible maintenant
          </span>
        </div>
      )}

      <div className="mb-6">
        <div className="text-3xl mb-3">{emoji}</div>
        <div className="flex items-center gap-2 mb-1">
          <h3 className="font-display font-semibold text-xl text-kart-night">{name}</h3>
          {badge && (
            <span className="text-xs bg-kart-teal/15 text-kart-teal font-medium px-2 py-0.5 rounded-full">
              {badge}
            </span>
          )}
        </div>
        <div className="text-3xl font-display font-semibold text-kart-night mb-1">{price}</div>
        <p className="text-slate-500 text-sm">{description}</p>
      </div>

      <ul className="flex-1 space-y-3 mb-8">
        {features.map((f, i) => (
          <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700">
            <span className="text-kart-teal mt-0.5 shrink-0">✓</span>
            {f}
          </li>
        ))}
      </ul>

      {available ? (
        <CTAButton
          to={ctaTo || '/login'}
          variant={highlight ? 'primary' : 'ghost'}
          className="w-full"
        >
          {cta}
        </CTAButton>
      ) : (
        <div className="text-center text-sm text-slate-400 py-3 border-2 border-dashed border-slate-200 rounded-xl">
          À venir
        </div>
      )}
    </div>
  )
}
